(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[495],{

/***/ 7572:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/register",
      function () {
        return __webpack_require__(98726);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 98726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ register; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./styles/modules/Register.module.scss
var Register_module = __webpack_require__(30969);
var Register_module_default = /*#__PURE__*/__webpack_require__.n(Register_module);
// EXTERNAL MODULE: ./styles/modules/BlockContent.module.scss
var BlockContent_module = __webpack_require__(63443);
var BlockContent_module_default = /*#__PURE__*/__webpack_require__.n(BlockContent_module);
// EXTERNAL MODULE: ./components/Button.js + 2 modules
var Button = __webpack_require__(44217);
;// CONCATENATED MODULE: ./components/BlockContent.js



var BlockContent = function(props) {
    var data = props.data;
    if (!data) return null;
    var _theme;
    var theme = (_theme = props.theme) !== null && _theme !== void 0 ? _theme : "white";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: [
            "border-accent",
            (BlockContent_module_default()).block,
            (BlockContent_module_default())[theme]
        ].join(" "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: data.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: data.body
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: [
                    (BlockContent_module_default()).block__buttons,
                    (BlockContent_module_default())["block__buttons--login"], 
                ].join(" "),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: props.onClick,
                        theme: "primary",
                        title: data.button.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: props.onClickRegisterJournalist,
                        theme: "outline",
                        title: "I'M A JOURNALIST"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_BlockContent = (BlockContent);

// EXTERNAL MODULE: ./lang/en.json
var en = __webpack_require__(64798);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./next-seo.config.js
var next_seo_config = __webpack_require__(5056);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./store/index.js
var store = __webpack_require__(23261);
;// CONCATENATED MODULE: ./pages/register/index.js











var Register = function() {
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, next_seo_config/* default */.Z), {
                titleTemplate: "Register | %s"
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: [
                    "container",
                    (Register_module_default()).pageRegister
                ].join(" "),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        flex: 1
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: [
                                "row",
                                (Register_module_default()).row
                            ].join(" "),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BlockContent, {
                                theme: "primary",
                                data: {
                                    title: en/* registration.start.title */.l9.BL.TN,
                                    body: en/* registration.start.body */.l9.BL.d1,
                                    button: {
                                        title: en/* registration.start.button */.l9.BL.LI
                                    }
                                },
                                onClickRegisterJournalist: function() {
                                    router.push({
                                        pathname: "/register/journalist",
                                        query: router.query
                                    });
                                },
                                onClick: function() {
                                    // setFormData({ ...formData, type: 'company' });
                                    router.push({
                                        pathname: "/register/profile",
                                        query: router.query
                                    });
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Register_module_default()).login,
                            children: [
                                "Already have a Newspage?",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/login",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: "Log in"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Register_module_default()).login,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "mailto:dominic@newspage.media?subject=We are a PR agency interested in using Newspage&body=Send us your agency’s name, URL and the best number to call you on and we’ll be in touch ASAP",
                                children: "Are you a PR agency?"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var register = (store/* wrapper.withRedux */.Y.withRedux(Register));


/***/ }),

/***/ 63443:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"block":"BlockContent_block__RF4Cd","block__buttons":"BlockContent_block__buttons__YCSwA","block__buttons--login":"BlockContent_block__buttons--login__XRV_u","white":"BlockContent_white__6Bzja","primary":"BlockContent_primary__x9rKp"};

/***/ }),

/***/ 30969:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pageRegister":"Register_pageRegister__Becit","row":"Register_row__CIXEf","rowVc":"Register_rowVc__GlMFG","rowSb":"Register_rowSb__GVnAk","login":"Register_login__bvZoZ","subscription":"Register_subscription__p4RMU"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(7572); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);